import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useFavicon = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Trigger favicon reload when location changes
    const triggerFaviconReload = () => {
      // Dispatch a custom event that the FaviconManager can listen to
      window.dispatchEvent(new CustomEvent('routeChange'));
      
      // Also force a favicon reload directly
      const faviconPath = `${process.env.PUBLIC_URL}/assets/Virtual Triage.png`;
      const timestamp = new Date().getTime();
      
      // Remove existing favicon links
      const existingLinks = document.querySelectorAll('link[rel*="icon"]');
      existingLinks.forEach(link => link.remove());
      
      // Create new favicon links
      const sizes = ['16x16', '32x32', '192x192', '512x512'];
      sizes.forEach(size => {
        const link = document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/png';
        link.sizes = size;
        link.href = `${faviconPath}?v=${timestamp}`;
        document.head.appendChild(link);
      });
      
      // Add apple touch icon
      const appleTouchIcon = document.createElement('link');
      appleTouchIcon.rel = 'apple-touch-icon';
      appleTouchIcon.sizes = '180x180';
      appleTouchIcon.href = `${faviconPath}?v=${timestamp}`;
      document.head.appendChild(appleTouchIcon);
      
      // Add shortcut icon
      const shortcutIcon = document.createElement('link');
      shortcutIcon.rel = 'shortcut icon';
      shortcutIcon.href = `${faviconPath}?v=${timestamp}`;
      document.head.appendChild(shortcutIcon);
    };
    
    // Trigger favicon reload when location changes
    triggerFaviconReload();
  }, [location]);
}; 